'use client';
import { StoreProvider } from 'easy-peasy';
import React from 'react';
import store from '../store';

const StoreProviders = ({ children }: any) => {
  return <StoreProvider store={store}>{children}</StoreProvider>;
};

export default StoreProviders;
